export const isTestEmailCompatible = (tags) => {
    return tags.includes("internal:testEmailCompatible");
};
